import React from 'react'
import { getDeepValueByPath } from '../common/utils';

const HistoryTableHeader = (props) => {
    const { editedFields, captions, objectData, title, extraProperties } = props;

    const createCapture = () => { 
      if (!title)
        return null;
      return title.map((item, idx) => {
        return (
          <div className="capture" key={idx}>
            <strong>{item.title}</strong>
            :
            <span> {item.value}</span>
          </div>
        )
    })};

    const mapContent = () => {
      if (!editedFields || !objectData)
        return null;
      const resultData = {};
      editedFields.forEach((keyField) => {
        if (!extraProperties || !extraProperties.includes(keyField)) {
          const value = getDeepValueByPath(objectData, keyField);
          resultData[keyField] = value;
        }
      });
      return resultData;
    };

    const renderContent = () => {
      const fields = mapContent();
      return fields ? Object.keys(fields).map((key) => <div>{`${captions[key]}: ${fields[key]}`}</div>) : null;
    };

    return (
        <React.Fragment>
            {createCapture()}
            {renderContent()}
        </React.Fragment>
    );

};

export default HistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/historyTableHeader.js